import { FC, ReactElement, useEffect, useState } from 'react';

import { Icon } from '@pp/core/src/components/icons/icon';
import { Icons } from '@pp/core/src/components/icons/iconNames';
import { L10nText } from '@pp/core/src/services/uiTranslations/reactBindings/L10nText';
import { Tooltip } from '@pp/core/src/components/tooltip/Tooltip';
import { useGameStateSlice } from '@pp/core/src/store/slices/game/selectors';
import { GameStatus } from '@pp/core/src/store/slices/game/types';

import { useRecentResultDetailStateSlice } from '../../../store/slices/recentResultDetail/selectors';
import styles from '../../recentResults/singleResult/SingleResult.module.css';

const TimerButton: FC = (): ReactElement => {
  const timeRemaining = useRecentResultDetailStateSlice.getTimeRemaining();
  const isGameCancelled = useGameStateSlice.getCurrentStatus() === GameStatus.GameCancelled;

  const [element, setElement] = useState(<span></span>);
  useEffect(() => {
    if (isGameCancelled) {
      setElement(
        <span>
          <Icon className={styles.cancelledIcon} icon={Icons.CancelledResults}></Icon>
        </span>
      );
    } else {
      if (timeRemaining <= 0) {
        setElement(
          <span>
            <L10nText tk="IN_PLAY_CAPS" />
          </span>
        );
      } else {
        setElement(
          <span>
            {timeRemaining}
            <L10nText tk="NXT_GAME_10" />
          </span>
        );
      }
    }
  }, [isGameCancelled, timeRemaining]);

  return (
    <Tooltip text={'GAMECANCELLED'} disabled={!isGameCancelled}>
      <div
        className={`${styles.singleResult} ${styles.btnValue0} ${styles.modalButtonSingle} ${isGameCancelled && styles.cancelledResults}`}
      >
        {element}
      </div>
    </Tooltip>
  );
};

export default TimerButton;
